module.exports = __webpack_public_path__ + "img/avb.d593430.webp";